// extracted by mini-css-extract-plugin
export var alignDiscLeft = "p_qZ d_fp d_bG d_dv";
export var alignLeft = "p_qp d_fp d_bG d_dv";
export var alignDiscCenter = "p_q0 d_fq d_bD d_dw";
export var alignCenter = "p_bP d_fq d_bD d_dw";
export var alignDiscRight = "p_q1 d_fr d_bH d_dx";
export var alignRight = "p_qq d_fr d_bH d_dx";
export var footerContainer = "p_q2 d_dW d_bW";
export var footerContainerFull = "p_q3 d_dT d_bW";
export var footerHeader = "p_kf d_kf";
export var footerTextWrapper = "p_q4 d_w";
export var footerDisclaimerWrapper = "p_km d_km d_ck";
export var badgeWrapper = "p_q5 d_w d_bz d_bP d_bF d_bJ";
export var verticalTop = "p_q6 d_bz d_bJ d_bN d_bL";
export var wide = "p_q7 d_cy";
export var right = "p_q8 d_bK";
export var line = "p_fk d_fl d_cv";
export var badgeDisclaimer = "p_q9 d_bC d_bP d_bJ";
export var badgeContainer = "p_rb d_bz d_bH d_bP";
export var badge = "p_rc";
export var padding = "p_rd d_c7";
export var end = "p_rf d_bH";
export var linkWrapper = "p_rg d_dB";
export var link = "p_mC d_dB";
export var colWrapper = "p_rh d_cx";
export var consent = "p_f d_f d_bC d_bP";
export var disclaimer = "p_rj d_bz d_bJ";
export var media = "p_rk d_bx d_dy";
export var itemRight = "p_rl";
export var itemLeft = "p_rm";
export var itemCenter = "p_rn";
export var exceptionWeight = "p_rp t_sk";